/*
 * File: d:\projects\AutoFiFront\src\Content\Header\Header.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday January 13th 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Tuesday, 27th August 2024 02:08:12
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { useEffect, useState } from "react";
import translator from "MultiLanguage/TranslationWrapper";
import styles from "Content/Header/Header.module.css";
import NavLinkStyled from "Theme/Component/NavLinkStyled";
import { NavLink, useNavigate } from "react-router-dom";
import PhoneMenu from "Theme/Component/PhoneMenu";
import 'Content/Header/Header.css';
import 'Content/Header/Header.module.css';
import RouterPathResolver from "Config/Router/RouterPathResolver";
import { RiUser3Line } from "react-icons/ri";
import { getThemeColor } from "Utils/ThemeColor";
import { useAuth } from "Router/AuthProvider";
import HeaderMenu from "./HeaderMenu/HeaderMenu";
import HeaderCart from "./HeaderIcons/HeaderCart/HeaderCart";

const HeaderList = [
    {name: "home", path: RouterPathResolver.pathEntryPoint.path},
    {name: "carList", path:RouterPathResolver.routeCars.path},
    {name: "financement", path:RouterPathResolver.routeFinance.path},
    {name: "about", path:RouterPathResolver.routeAbout.path}
];

type HeaderPropsType = {
    themeColor: string,
    changeThemeColor: React.Dispatch<React.SetStateAction<string>>
};

type NavlinkStyleActiveType = {
    isActive: boolean,
    isPending: boolean
};

function Header(props: HeaderPropsType){
    const [toggleClass, settoggleClass] = useState(false);
    const navigate = useNavigate();
    const { isConnected } = useAuth();

    const toggle: any = () => {
        settoggleClass(!toggleClass);
    };
    useEffect(()=>{
        if(toggleClass)
            settoggleClass(!toggleClass);
    }, [navigate]);

    const resetThemeColor: any = () => {
        return props.changeThemeColor("");
    };

    const activeStyle = {
        color: getThemeColor(props.themeColor)
    };

    return (
        <header>
            <div className={`${styles.header}`}>
                <NavLink className={`${styles.linkLogoHome}`} aria-label="Home Link" to={RouterPathResolver.pathEntryPoint.path}>
                    <img src="/mobyfleet_logo.png" alt="logo mobyfleet" />
                </NavLink>
                <div className={`${styles.header_ul_wrapper}`}>
                    <ul className={`${styles.header_ul}`}>
                        {
                            HeaderList.map((item)=> {return <li key={item.name}>
                                <NavLinkStyled onClick={resetThemeColor} bgColor={props.themeColor} style={(activeParam: NavlinkStyleActiveType) => ( activeParam.isActive ? activeStyle : {} )}
                                    to={item.path}>
                                    {translator.decode(`navbar.${item.name}`).toUpperCase()}
                                </NavLinkStyled>
                            </li>})
                        }
                    </ul>
                </div>
                <div className={`${styles.iconsHeader}`}>
                    {
                        isConnected ?
                        <>
                            <HeaderCart />
                            <HeaderMenu />
                        </>
                        :
                        <>
                            <RiUser3Line style={{cursor:"pointer"}} size="2.5rem" onClick={() => navigate(RouterPathResolver.routeLogin.path)} fill="var(--theme-color)" />
                            <div className={`${styles.menuBar}`} >
                                <HeaderMenu />
                            </div>
                        </>
                    }
                </div>
            </div>
            <div className={`${toggleClass ? styles.hidden: styles.hiddenBis}`}>
                <div className={`${toggleClass ? styles.navPhoneRight : styles.displayNone}`}>
                    <div className={`${styles.nav}`}>
                        <ul className={`${styles.header_ul_phone}`}>
                            {
                                HeaderList.map((item)=> {return <li key={item.name}>
                                    <NavLink onClick={() => {resetThemeColor(); toggle()}} className={`${styles.liPhone}`} to={item.path}>
                                        {translator.decode(`navbar.${item.name}`)}
                                    </NavLink>
                                </li>})
                            }
                        </ul>
                    </div>
                    <div className={`${styles.menuPhonePop}`}>
                        <PhoneMenu bgColor={props.themeColor} />
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header;
